module.exports = __webpack_public_path__ + "img/清风.b71f681c.png";